import { useEffect, useState } from 'react';

/**
 * `prefers-reduced-motion: reduce` as a boolean.
 *
 * CSS selector: none, this is the JS half of the media query.
 *
 * Doctrine: the Sheet is the only organism in this layer that animates, and
 * PREFERENCES puts transitions at 120 to 200ms with 2px lifts maximum. Motion
 * that a user has asked not to see must not run at all, so the drill-in slide
 * is switched off here rather than merely shortened. Read synchronously on
 * first render so the very first transition is already correct.
 *
 * Local to the organisms directory on purpose. `design-system/hooks/` is owned
 * by another track, and promoting this belongs to a later consolidation pass.
 */
const QUERY = '(prefers-reduced-motion: reduce)';

function read() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function useReducedMotion() {
  const [reduced, setReduced] = useState(read);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (event) => setReduced(event.matches);
    setReduced(mql.matches);
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return reduced;
}

export default useReducedMotion;
